/**
 * Generated by orval v8.17.0 🍺
 * Do not edit manually.
 * Server, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  ChatRequest,
  ChatResponse,
  GenerateMermaidRequest,
  GenerateMermaidResponse,
  HttpValidationProblemDetails,
  ProblemDetails,
  VectorChatRequest,
  VectorStoreUploadRequest,
  VectorStoreUploadResponse
} from '../models';

import { customInstance } from '../../../orvalCustomAxiosInstance';
import type { ErrorType } from '../../../orvalCustomAxiosInstance';




export const postApiOpenAIGenerateMermaid = (
    generateMermaidRequest?: GenerateMermaidRequest,
 signal?: AbortSignal
) => {


      return customInstance<GenerateMermaidResponse>(
      {url: `/api/OpenAI/generate-mermaid`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: generateMermaidRequest, signal
    },
      );
    }



export const getPostApiOpenAIGenerateMermaidMutationOptions = <TError = ErrorType<ProblemDetails | HttpValidationProblemDetails | GenerateMermaidResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiOpenAIGenerateMermaid>>, TError,{data?: GenerateMermaidRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiOpenAIGenerateMermaid>>, TError,{data?: GenerateMermaidRequest}, TContext> => {

const mutationKey = ['postApiOpenAIGenerateMermaid'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiOpenAIGenerateMermaid>>, {data?: GenerateMermaidRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiOpenAIGenerateMermaid(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiOpenAIGenerateMermaidMutationResult = NonNullable<Awaited<ReturnType<typeof postApiOpenAIGenerateMermaid>>>
    export type PostApiOpenAIGenerateMermaidMutationBody = GenerateMermaidRequest | undefined
    export type PostApiOpenAIGenerateMermaidMutationError = ErrorType<ProblemDetails | HttpValidationProblemDetails | GenerateMermaidResponse>

    export const usePostApiOpenAIGenerateMermaid = <TError = ErrorType<ProblemDetails | HttpValidationProblemDetails | GenerateMermaidResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiOpenAIGenerateMermaid>>, TError,{data?: GenerateMermaidRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiOpenAIGenerateMermaid>>,
        TError,
        {data?: GenerateMermaidRequest},
        TContext
      > => {
      return useMutation(getPostApiOpenAIGenerateMermaidMutationOptions(options), queryClient);
    }
    export const postApiOpenAIChat = (
    chatRequest?: ChatRequest,
 signal?: AbortSignal
) => {


      return customInstance<ChatResponse>(
      {url: `/api/OpenAI/chat`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: chatRequest, signal
    },
      );
    }



export const getPostApiOpenAIChatMutationOptions = <TError = ErrorType<ProblemDetails | HttpValidationProblemDetails | ChatResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiOpenAIChat>>, TError,{data?: ChatRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiOpenAIChat>>, TError,{data?: ChatRequest}, TContext> => {

const mutationKey = ['postApiOpenAIChat'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiOpenAIChat>>, {data?: ChatRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiOpenAIChat(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiOpenAIChatMutationResult = NonNullable<Awaited<ReturnType<typeof postApiOpenAIChat>>>
    export type PostApiOpenAIChatMutationBody = ChatRequest | undefined
    export type PostApiOpenAIChatMutationError = ErrorType<ProblemDetails | HttpValidationProblemDetails | ChatResponse>

    export const usePostApiOpenAIChat = <TError = ErrorType<ProblemDetails | HttpValidationProblemDetails | ChatResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiOpenAIChat>>, TError,{data?: ChatRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiOpenAIChat>>,
        TError,
        {data?: ChatRequest},
        TContext
      > => {
      return useMutation(getPostApiOpenAIChatMutationOptions(options), queryClient);
    }
    export const postApiOpenAIVectorChat = (
    vectorChatRequest?: VectorChatRequest,
 signal?: AbortSignal
) => {


      return customInstance<ChatResponse>(
      {url: `/api/OpenAI/vector-chat`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: vectorChatRequest, signal
    },
      );
    }



export const getPostApiOpenAIVectorChatMutationOptions = <TError = ErrorType<ProblemDetails | HttpValidationProblemDetails | ChatResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiOpenAIVectorChat>>, TError,{data?: VectorChatRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiOpenAIVectorChat>>, TError,{data?: VectorChatRequest}, TContext> => {

const mutationKey = ['postApiOpenAIVectorChat'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiOpenAIVectorChat>>, {data?: VectorChatRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiOpenAIVectorChat(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiOpenAIVectorChatMutationResult = NonNullable<Awaited<ReturnType<typeof postApiOpenAIVectorChat>>>
    export type PostApiOpenAIVectorChatMutationBody = VectorChatRequest | undefined
    export type PostApiOpenAIVectorChatMutationError = ErrorType<ProblemDetails | HttpValidationProblemDetails | ChatResponse>

    export const usePostApiOpenAIVectorChat = <TError = ErrorType<ProblemDetails | HttpValidationProblemDetails | ChatResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiOpenAIVectorChat>>, TError,{data?: VectorChatRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiOpenAIVectorChat>>,
        TError,
        {data?: VectorChatRequest},
        TContext
      > => {
      return useMutation(getPostApiOpenAIVectorChatMutationOptions(options), queryClient);
    }
    export const postApiOpenAIUploadToVectorStore = (
    vectorStoreUploadRequest?: VectorStoreUploadRequest,
 signal?: AbortSignal
) => {


      return customInstance<VectorStoreUploadResponse>(
      {url: `/api/OpenAI/upload-to-vector-store`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: vectorStoreUploadRequest, signal
    },
      );
    }



export const getPostApiOpenAIUploadToVectorStoreMutationOptions = <TError = ErrorType<ProblemDetails | HttpValidationProblemDetails | VectorStoreUploadResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiOpenAIUploadToVectorStore>>, TError,{data?: VectorStoreUploadRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiOpenAIUploadToVectorStore>>, TError,{data?: VectorStoreUploadRequest}, TContext> => {

const mutationKey = ['postApiOpenAIUploadToVectorStore'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiOpenAIUploadToVectorStore>>, {data?: VectorStoreUploadRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiOpenAIUploadToVectorStore(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiOpenAIUploadToVectorStoreMutationResult = NonNullable<Awaited<ReturnType<typeof postApiOpenAIUploadToVectorStore>>>
    export type PostApiOpenAIUploadToVectorStoreMutationBody = VectorStoreUploadRequest | undefined
    export type PostApiOpenAIUploadToVectorStoreMutationError = ErrorType<ProblemDetails | HttpValidationProblemDetails | VectorStoreUploadResponse>

    export const usePostApiOpenAIUploadToVectorStore = <TError = ErrorType<ProblemDetails | HttpValidationProblemDetails | VectorStoreUploadResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiOpenAIUploadToVectorStore>>, TError,{data?: VectorStoreUploadRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiOpenAIUploadToVectorStore>>,
        TError,
        {data?: VectorStoreUploadRequest},
        TContext
      > => {
      return useMutation(getPostApiOpenAIUploadToVectorStoreMutationOptions(options), queryClient);
    }
